const formatCnpj = (cnpj) => {
  if (cnpj) {
    return cnpj
      .toUpperCase()
      .replace(
        /^([\dA-Z]{2})([\dA-Z]{3})([\dA-Z]{3})([\dA-Z]{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
  }
  return cnpj;
};

export default formatCnpj;
